import React from 'react'
import { Signup } from '../src'
import { OnboardingType, ShellProps } from '../src/types'
import projectNames from '../src/configs/projectNames'
import { SessionData } from '../src/lib/sessionData'
import { loadDevTools } from '../src/lib/loadDevTools'

declare global {
  interface Window {
    Shell: ShellProps
  }
}
/**
 * @function Root Main function
 * @param props
 * @returns
 */
export default function Root({ stack, properties }) {
  const { v1 } = window.Shell as ShellProps
  const {
    analytics,
    authProvider,
    navigation,
    store,
    localization,
    serviceRouting,
    sessionInterface,
    tenantHandlerInterface,
    userSession
  } = v1

  const onboarding = store?.state?.onboarding
    ? { ...(store?.state?.onboarding as OnboardingType) }
    : { ...(new SessionData('onboardingStateData').get() as OnboardingType) }

  loadDevTools(stack)

  // You can find the "stack" information by props
  // const stack = props.stack.
  return (
    <section
      className={`${projectNames.namespace}`}
      id={projectNames.packageJsonName}
    >
      <Signup
        stack={stack}
        properties={properties}
        onboarding={onboarding}
        analytics={analytics}
        authProvider={authProvider}
        navigation={navigation}
        localization={localization}
        serviceRouting={serviceRouting}
        sessionInterface={sessionInterface}
        tenantHandlerInterface={tenantHandlerInterface}
        userSession={userSession}
      />
    </section>
  )
}
